// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import Card from 'antd/lib/card';
import ClientHeaderRight from './ClientHeaderRight';
import ClientHeaderCenter from './ClientHeaderCenter';
import ClientHeaderLeft from './ClientHeaderLeft';

// CONSTANTS & DESTRUCTURING
// ===================================

// STYLES
// ===================================

export class ClientHeader extends React.Component {
  render() {
    console.log(this.props.client);
    return (
      <div className="section-row">
        <Card style={{ minHeight: 200, flex: 1 }}>
          <Row align="flex-start">
            <Col xs={24} sm={5}>
              <ClientHeaderLeft client={this.props.client} />
            </Col>
            <Col xs={24} sm={12}>
              <ClientHeaderCenter client={this.props.client} onToggleEdit={() => this.props.onToggleEdit()} />
            </Col>
            <Col xs={24} sm={7}>
              <ClientHeaderRight client={this.props.client} />
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}

export default ClientHeader;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientHeader/index.js